// Account context reducer provider & hooks

import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useContext, useEffect } from "react";

const { createContext } = require("react");
const { useReducer } = require("react");

const initialState = {
  user: undefined,
  isSubscribed: undefined,
  isFreeSubscription: false,
};

const accountReducer = (state, a) => {
  switch (a.type) {
    case "setUser":
      return { ...state, user: a.user };
    case "setSubscribed":
      return {
        ...state,
        isSubscribed: a.isSubscribed,
        isFreeSubscription: a.isFree,
      };
    default:
      throw new Error("Invalid action type");
  }
};

const AccountContext = createContext([initialState, () => {}]);

export const AccountProvider = ({ children }) => {
  const [state, dispatch] = useReducer(accountReducer, initialState);

  // Update state and auth token when auth state changes
  useEffect(
    () =>
      onAuthStateChanged(getAuth(), async (u) => {
        dispatch({ type: "setUser", user: u });

        if (u) {
          axios.defaults.headers = {
            Authorization: `Bearer ${await u.getIdToken()}`,
          };

          const { data } = await axios.get("/my-account-status");
          dispatch({
            type: "setSubscribed",
            isSubscribed: data.isSubscribed,
            isFree: data.isFree,
          });
        } else delete axios.defaults.headers.Authorization;
      }),
    []
  );

  return (
    <AccountContext.Provider value={[state, dispatch]}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccountContext = () => useContext(AccountContext);
export const useAccount = () => useAccountContext()?.[0];
export const useUser = () => useAccount()?.user;
